"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetDamages = exports.deleteManyDamages = exports.deletedOneDamage = exports.updatedManyDamages = exports.updatedOneDamage = exports.gotManyDamages = exports.gotOneDamage = void 0;
var index_1 = __importDefault(require("./index"));
var _a = index_1.default.actions, gotOne = _a.gotOne, gotMany = _a.gotMany, updatedOne = _a.updatedOne, updatedMany = _a.updatedMany, deletedOne = _a.deletedOne, deleteMany = _a.deleteMany, reset = _a.reset;
exports.gotOneDamage = gotOne;
exports.gotManyDamages = gotMany;
exports.updatedOneDamage = updatedOne;
exports.updatedManyDamages = updatedMany;
exports.deletedOneDamage = deletedOne;
exports.deleteManyDamages = deleteMany;
exports.resetDamages = reset;
//# sourceMappingURL=actions.js.map